import _reactivityCjsProd from "./dist/reactivity.cjs.prod.js";
export { _reactivityCjsProd as default };
export const __esModule = _reactivityCjsProd.__esModule,
      ITERATE_KEY = _reactivityCjsProd.ITERATE_KEY,
      computed = _reactivityCjsProd.computed,
      customRef = _reactivityCjsProd.customRef,
      effect = _reactivityCjsProd.effect,
      enableTracking = _reactivityCjsProd.enableTracking,
      isProxy = _reactivityCjsProd.isProxy,
      isReactive = _reactivityCjsProd.isReactive,
      isReadonly = _reactivityCjsProd.isReadonly,
      isRef = _reactivityCjsProd.isRef,
      markRaw = _reactivityCjsProd.markRaw,
      pauseTracking = _reactivityCjsProd.pauseTracking,
      proxyRefs = _reactivityCjsProd.proxyRefs,
      reactive = _reactivityCjsProd.reactive,
      readonly = _reactivityCjsProd.readonly,
      ref = _reactivityCjsProd.ref,
      resetTracking = _reactivityCjsProd.resetTracking,
      shallowReactive = _reactivityCjsProd.shallowReactive,
      shallowReadonly = _reactivityCjsProd.shallowReadonly,
      shallowRef = _reactivityCjsProd.shallowRef,
      stop = _reactivityCjsProd.stop,
      toRaw = _reactivityCjsProd.toRaw,
      toRef = _reactivityCjsProd.toRef,
      toRefs = _reactivityCjsProd.toRefs,
      track = _reactivityCjsProd.track,
      trigger = _reactivityCjsProd.trigger,
      triggerRef = _reactivityCjsProd.triggerRef,
      unref = _reactivityCjsProd.unref;